import { Component, Input } from '@angular/core';

export type StatusType = 'Awaiting Payment' | 'Paid' | 'Voided';
export type IntegrationType = 'Xero' | 'QBO' | 'None';

@Component({
  selector: 'app-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss']
})
export class StatusPillComponent {
  @Input() status: StatusType = 'Awaiting Payment';
  @Input() integrationType: IntegrationType = 'None';
  @Input() showIcon: boolean = true;

  get logoSrc(): string {
    switch (this.integrationType) {
      case 'Xero':
        return 'assets/img/Xero.png';
      case 'QBO':
        return 'assets/img/QuickBookConnectLogo.png';
      default:
        return '';
    }
  }

  get logoAlt(): string {
    switch (this.integrationType) {
      case 'Xero':
        return 'Xero';
      case 'QBO':
        return 'QuickBooks';
      default:
        return '';
    }
  }

  get pillClass(): string {
    switch (this.integrationType) {
      case 'Xero':
        return 'xero-pill';
      case 'QBO':
        return 'qbo-pill';
      default:
        return 'default-pill';
    }
  }
}
